import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import ModalShell from '../shared/ModalShell';

const StatusUpdateModal = ({
 isOpen,
 onClose,
 currentStatus,
 onUpdate,
 isUpdating = false,
}) => {
 const [newStatus, setNewStatus] = useState('');
 const [statusReason, setStatusReason] = useState('');

 useEffect(() => {
 if (isOpen) {
 setNewStatus('cancelled');
 }
 }, [isOpen]);

 const isCompleted = currentStatus === 'completed';

 const handleSubmit = (e) => {
 e.preventDefault();
 if (newStatus && newStatus !== currentStatus) {
 onUpdate(newStatus, statusReason);
 }
 };

 const handleClose = () => {
 setNewStatus('');
 setStatusReason('');
 onClose();
 };

 return (
 <ModalShell
 isOpen={isOpen}
 onClose={() => !isUpdating && handleClose()}
 labelledBy="cancel-booking-title"
 panelClassName="max-w-md"
 >
 <div className="bg-surface rounded-lg border border-border shadow-sm max-w-md w-full relative overflow-hidden">
 <button
 type="button"
 onClick={handleClose}
 className="absolute top-4 right-4 text-gray-400 hover:text-gray-700 transition-colors z-10"
 aria-label="Close"
 >
 <X className="w-5 h-5" />
 </button>

 <div className="p-6 border-b border-border">
 <h2 id="cancel-booking-title" className="text-xl font-bold text-ink mb-2">
 Cancel Booking
 </h2>
 {isCompleted ? (
 <p className="text-sm text-red-600 font-medium">
 This booking is already completed and cannot be cancelled.
 </p>
 ) : (
 <p className="text-sm text-ink-secondary">Cancel this booking</p>
 )}
 </div>

 {isCompleted ? (
 <div className="p-6">
 <div className="rounded-xl border border-border bg-surface-muted p-4 text-center">
 <p className="text-sm text-ink-secondary">
 Completed bookings cannot be modified.
 </p>
 </div>
 <div className="mt-6 flex justify-end">
 <button
 type="button"
 onClick={handleClose}
 className="px-4 py-2 bg-black text-white rounded-md hover:bg-gray-900 transition-colors text-sm font-medium"
 >
 Close
 </button>
 </div>
 </div>
 ) : (
 <form onSubmit={handleSubmit}>
 <div className="p-6 space-y-4">
 <div>
 <label className="block text-sm font-medium text-ink-secondary mb-2">
 Current Status
 </label>
 <div className="px-3 py-2 bg-surface-muted border border-border rounded-xl text-sm text-ink-secondary">
 {currentStatus?.replace('_', ' ').replace(/\b\w/g, (l) => l.toUpperCase()) || 'N/A'}
 </div>
 </div>

 <div>
 <label className="block text-sm font-medium text-ink-secondary mb-2">
 Confirm Cancellation <span className="text-red-500">*</span>
 </label>
 <div className="px-3 py-2 bg-red-50 border border-red-300 rounded-xl text-sm text-red-700 font-medium">
 Cancelled
 </div>
 </div>

 <div>
 <label className="block text-sm font-medium text-ink-secondary mb-2">
 Reason (Optional)
 </label>
 <textarea
 value={statusReason}
 onChange={(e) => setStatusReason(e.target.value)}
 placeholder="Reason for status change..."
 rows={3}
 className="w-full px-3 py-2 border border-border bg-surface text-ink rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-ink/40 focus:border-ink resize-none"
 />
 </div>
 </div>

 <div className="p-6 border-t border-border flex justify-end gap-3">
 <button
 type="button"
 onClick={handleClose}
 className="px-4 py-2 border border-border text-gray-800 rounded-md hover:bg-surface-muted transition-colors text-sm font-medium"
 >
 Cancel
 </button>
 <button
 type="submit"
 disabled={!newStatus || newStatus === currentStatus || isUpdating}
 className="px-4 py-2 bg-black text-white rounded-md hover:bg-gray-900 transition-colors text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed"
 >
 {isUpdating ? 'Cancelling...' : 'Cancel Booking'}
 </button>
 </div>
 </form>
 )}
 </div>
 </ModalShell>
 );
};

export default StatusUpdateModal;
